var skus = [];


 initVariationOption();
 function initVariationOption(){
   if(location.href.indexOf('collections')!=-1 && location.href.indexOf('products') ==-1){
        $(".card__heading").each(function(){
          try{
            let content_id = $(this).closest(".card__content").attr("id");
            let product_id = content_id.replace("content_","");
            //let product_with_sku_json = $("#grid_"+product_id+" > div.product_json").text()
            let product_with_sku_json = $("#grid_"+product_id+" > .product_json").text()
            let sku = $(this).closest(".card-wrapper").data("sku");
            let section_id = $(this).closest(".card-wrapper").data("section_id");
            let variants_count = $(this).closest(".card-wrapper").data("variants_count");
            variants_count = (variants_count === undefined || variants_count === "undefined")?0:Number(variants_count);
            let source_product_handle = $(this).closest(".card-wrapper").data("source_product_handle");
            // if(variants_count >1)return;
            if(product_with_sku_json){
              product_with_sku_json = JSON.parse(product_with_sku_json);
              //initProductGroupSku(sku,product_id,product_with_sku_json,section_id);
            }
          }catch(e){
            console.log(e);
          }
        });
  }
 }



function initProductGroupSku(sku,product_source_id,product_with_sku_json,section_id){
    if(skus.includes(product_source_id))return;
    skus.push(product_source_id);
    let items = product_with_sku_json;
    let html = "";
        let colours = [];
        if (items.length <= 1) {
          try{
             document.querySelector("div[data-id='" + item["id"] + "']").closest(".card-information").querySelector(".product_tile_color_holder").style.display="none";
             return;
          }catch(e){
            
          }
        }
        let colour_name_key = "";
        let is_sold_out = 1;
        let type = '';
        let quantity_map = [];
        items.forEach((value) => {
          let options = [];
          value.options.forEach((option)=>{
            let key = option['name'];
            let value = option['values'][0];
            if (option['name'] == "Title") return;
            if (!options.hasOwnProperty(key)) { options[key] = [] }
            if (options[key].indexOf(value) == -1) {
                options[key].push(value);
            }
          });
          if(value.hasOwnProperty("type")){
            type = value['type'];
          }
          colour_name_key = Object.keys(options).filter((key)=>{return ["Stone Color","Enamel Color","Finish","Leather Color"].includes(key)});
          if(parseInt(value["variant"][0]["inventory_quantity"])){
            is_sold_out = 0;
          }
          if(parseInt(value["variant"][0]["inventory_quantity"]) > 0){
             quantity_map.push(value); 
          }
          if(colour_name_key.length <1)return;
          colour_name_key = colour_name_key[0];
          let colour_name = options[`${colour_name_key}`][0];
          colour_name = colour_name.trim(" ");
          if (colours.includes(colour_name)) return;
          colours.push(colour_name);
          let color_value = variant_color_config[colour_name];
          if(!color_value)return;
          if (color_value && color_value.indexOf("cdn.shopify") != -1) {
            html += `<span class="color_items"><span id="${value["product_id"]}_color_1" data-id="${value["product_id"]}" data-source_id="${product_source_id}" data-img="${value['src']}"  data-color_value="${color_value}" data-sku="${value['variant'][0]['sku']}" style="background: url(${color_value}); background-size: cover;background-repeat:no-repeat;background-position:center;" onclick="selectColour(this)"></span></span>`;
          } else {
            html += `<span class="color_items"><span id="${value["product_id"]}_color_1" data-id="${value["product_id"]}" data-source_id="${product_source_id}" data-img="${value['src']}"  data-color_value="${color_value}" data-sku="${value['variant'][0]['sku']}" style="background: ${color_value};" onclick="selectColour(this)"></span></span>`;
          }
        });
       try{
         let card_badge = document.querySelector("div[data-id='" + product_source_id + "']").closest(".card__content").querySelector(".card__badge span").innerText;
         if(!is_sold_out && card_badge == 'Sold out' && ['bracelet','bracelets','bracelet set'].includes(type)){
           document.querySelector(`#NoMediaStandardBadge-${section_id}-${product_source_id}`).setAttribute("class","badge badge--bottom-left color-accent-1");
           document.querySelector(`#NoMediaStandardBadge-${section_id}-${product_source_id}`).innerText="Sale";
           value = quantity_map[0];
           var link = document.querySelector(`#CardLink-${section_id}-${product_source_id}`).href;
           if(link.toLocaleUpperCase().indexOf('GNSO08549')!=-1){
                quantity_map.filter((v)=>{return v.indexOf('GNSO08549')!=-1});
                value = quantity_map[0];
           }
           let href = '/products/'+value['sku'].replace('.','-');
           document.querySelector(`#CardLink-${section_id}-${product_source_id}`).href=href;
           document.querySelector(`#StandardCardNoMediaLink-${section_id}-${product_source_id}`).href=href;
           //更新评分
           updateProductLoox(value['sku']);
         }
         // if(is_sold_out){
         //   document.querySelector(`#CardLink-${section_id}-${product_source_id}`).href="javascript:void(0);";
         //   document.querySelector(`#StandardCardNoMediaLink-${section_id}-${product_source_id}`).href="javascript:void(0);";
         // }
         if (colours.length <= 1) {
           if(document.querySelector("div[data-id='" + product_source_id + "']").closest(".card-information").querySelector(".product_tile_color_holder")){
            document.querySelector("div[data-id='" + product_source_id + "']").closest(".card-information").querySelector(".product_tile_color_holder").style.display="none";
            return;
           }
        }
         if(document.querySelector("div[data-id='" + product_source_id + "']").closest(".card-information").querySelector(".product_tile_color_holder")){
          document.querySelector("div[data-id='" + product_source_id + "']").closest(".card-information").querySelector(".product_tile_color_holder").innerHTML = html;
          document.querySelector("div[data-id='" + product_source_id + "']").closest(".card-information").querySelector(".product_tile_color_holder").style.display="block";
         }
       }catch(e){
         console.log(e);
       }    
}

var loox_data = [];
function updateProductLoox(sku,product_id){
  if(loox_data.length <= 0){
    loox_data =  JSON.parse(localStorage.getItem('loox_data'));
  }
  if(loox_data.hasOwnProperty(sku)){
    loox = loox_data[sku];
    showProductLoox(loox.avg_rating,loox.num_reviews);
  }else{
    $(`#loox-${product_id}`).hide();
  }
}

function showProductLoox(avg_rating,num_reviews){
  let html = `
  <div class="loox-rating-content">
    <svg class="loox-icon" viewBox="0 0 24 24" data-lx-fill="${lx_fill(avg_rating,1)}" role="img"><title>${avg_rating} rating (${num_reviews} votes)</title><use href="#looxicons-rating-icon"></use></svg>
    <svg class="loox-icon" viewBox="0 0 24 24" data-lx-fill="${lx_fill(avg_rating,2)}" aria-hidden="true"><use href="#looxicons-rating-icon"></use></svg>
    <svg class="loox-icon" viewBox="0 0 24 24" data-lx-fill="${lx_fill(avg_rating,3)}" aria-hidden="true"><use href="#looxicons-rating-icon"></use></svg>
    <svg class="loox-icon" viewBox="0 0 24 24" data-lx-fill="${lx_fill(avg_rating,4)}" aria-hidden="true"><use href="#looxicons-rating-icon"></use></svg>
    <svg class="loox-icon" viewBox="0 0 24 24" data-lx-fill="${lx_fill(avg_rating,5)}" aria-hidden="true"><use href="#looxicons-rating-icon"></use></svg>
  <span class="loox-rating-label">&nbsp;(2)</span>
  </div>
  `;
}

function lx_fill(avg_rating,index){
  if(parseInt(avg_rating) >= index){
    return 'full';
  }
  if(avg_rating - parseInt(avg_rating) >= 0.7 ){
    return 'full'
  }else if(avg_rating - parseInt(avg_rating) >= 0.1 ){
    return 'half';
  } else{
    return '';
  }
}

async function initLooxData(){
  let response = await fetch(`${main_api_url}/api/product-loox-all`);
  let {data} = await response.json();
  loox_data = data;

  //存储在本地
  localStorage.setItem('loox_data',JSON.stringify(loox_data));
}